import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const PREFERRED_LANG_KEY = "preferredLanguage";

const getLangFromUrl = (): "EN" | "ES" | null => {
  const path = window.location.pathname;
  const parts = path.split('/').filter(Boolean);
  if (parts.length > 0) {
    const lang = parts[0].toUpperCase();
    if (lang === "EN" || lang === "ES") {
      return lang as "EN" | "ES";
    } else {
      return "EN"
    }
  }
  return null;
};

const getInitialLang = (): "EN" | "ES" => {
    const urlLang = getLangFromUrl();
  if (urlLang) {
    localStorage.setItem(PREFERRED_LANG_KEY, urlLang);
    return urlLang;
  }
  const storedLang = localStorage.getItem(PREFERRED_LANG_KEY);
  if (storedLang === "ES" || storedLang === "EN") { 
    return storedLang.toUpperCase() as "EN" | "ES";
  } 
  return "EN"; 
};
const initialState = {
  language: getInitialLang(),
};

export const langSlice = createSlice({
  name: "lang",
  initialState: initialState,
  reducers: {
    setLang: (state, action: PayloadAction<"EN" | "ES">) => {
      state.language = action.payload;
      localStorage.setItem(PREFERRED_LANG_KEY, action.payload);
    },
  },
});

export const { setLang } = langSlice.actions;
